var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"cols":"5"}},[_c('b-button',{attrs:{"variant":"success","disabled":_vm.userPending,"block":""},on:{"click":_vm.sendPrice}},[_c('span',{staticClass:"buyNow"},[_vm._v("Buy Now")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }